export const initialFilters = {
    query: "",
};
export const initialProfile = {
    accountStatus: "BLOCK",
    countryId: "",
    createdAt: "",
    email: "",
    firstName: "",
    fullName: "",
    id: "",
    lastName: "",
    phoneNumber: "",
    profileImageUrl: "",
    roleIds: [],
    secondName: "",
    countryName: "",
};
export const initialLocalStore = {};
export const initialGlobalStore = {
    profile: initialProfile,
};
export const initialTableSettings = {
    pageSize: 5,
    pageIndex: 0,
    sortName: undefined,
    sortDirection: undefined,
};
export const initialState = {
    localStore: initialLocalStore,
    globalStore: initialGlobalStore,
};
//# sourceMappingURL=initialState.js.map